/*-------------Libraries----------------*/
import { makeAutoObservable, runInAction } from "mobx";

/*-------------Api----------------------*/
import agent from "../api/agent";

/*-------------Store--------------------*/
import { store } from "./store";

/*-------------Router-------------------*/
import router from "../router/Index";
import keycloak from "../../config/keycloak";

/*-------------Models-------------------*/
import { LoginAuthWrapper, SystemUser } from "../models/SystemUser";
import { AdminProfilePayload, Login } from "../models/Authentication";
import { AdminProfileApiResponse } from "../models/AdminProfile";

export default class UserStore {
  loginAuth: LoginAuthWrapper | null = null;
  user: SystemUser | null = null;
  loadingLogin: boolean = false;
  loadingVerifyOtp: boolean = false;
  adminUserProfile: AdminProfileApiResponse | null = null;
  userId: number | null = null;

  constructor() {
    makeAutoObservable(this);
    // const storedUserId = localStorage.getItem("userId");
    // if (storedUserId) {
    //     this.userId = Number(storedUserId);
    // }
  }

  get isLoggedIn() {
    return !!localStorage.getItem("user");
  }

  get isOtpVerified() {
    return !!localStorage.getItem("jwt");
  }

  login = async (creds: Login) => {
    this.setLoadingLogin(true);
    try {
      const user = await agent.User.login(creds);
      store.commonStore.setUserId(user.data.adminId);
      runInAction(() => (this.loginAuth = user));
      this.setLoadingLogin(false);
      router.navigate("/verify");
    } catch (error) {
      throw error;
    } finally {
      this.setLoadingLogin(false);
    }
  };

  logout = () => {
    store.commonStore.setToken(null);
    store.commonStore.setUser(null);
    this.user = null;
    this.adminUserProfile = null;
    if (keycloak.authenticated) {
      keycloak.logout({ redirectUri: window.location.origin + "/" });
    } else {
      router.navigate("/login");
    }
  };

  setLoadingLogin = (state: boolean) => {
    this.loadingLogin = state;
  };

  getAdminUserProfile = async (payload: AdminProfilePayload) => {
    this.setLoadingLogin(true);
    try {
      const params = new URLSearchParams();
      params.append("adminId", String(payload.adminId));

      const profileInst = await agent.User.getAdminProfile(params);
      runInAction(() => {
        this.adminUserProfile = profileInst;
        this.setLoadingLogin(false);
      });
    } catch (error) {
      this.setLoadingLogin(false);
    }
  };

  verifyOtp = async (keycloakToken: string) => {
    try {
      this.setLoadingVerifyOtp(true);
      const result = await agent.User.verifyOtp(keycloakToken);

      runInAction(() => {
        this.user = result;
      });
      store.commonStore.setUser(result);
      store.commonStore.setToken(result.data.token);
      store.commonStore.setRefreshToken(result.data.refreshToken);

      /* ── Fetch role menu actions to resolve menuId dynamically ── */
      const roleId = result.data.admin?.roleId;
      if (roleId) {
        try {
          const menuResponse = await agent.User.getRoleMenuAction(roleId);
          const menuData = menuResponse?.data ?? [];

          /* Search top-level items and their children for url === "customer-onboard" */
          let resolvedMenuId: number | null = null;
          const normalizeUrl = (url: string | null | undefined) =>
                        url ? url.replace(/^\//, '') : '';

          for (const item of menuData) {
            if (normalizeUrl(item.url) === "customer-onboard") {
              resolvedMenuId = item.menuId;
              break;
            }
            if (item.children) {
              const child = item.children.find(
                (c) => normalizeUrl(c.url) === "customer-onboard",
              );
              if (child) {
                resolvedMenuId = child.menuId;
                break;
              }
            }
          }

          if (resolvedMenuId !== null) {
            store.commonStore.setMenuId(resolvedMenuId);
          }
        } catch (error) {
          console.error(error);
        }
      }
      router.navigate("/");
      this.setLoadingVerifyOtp(false);
      return result;
    } catch (error) {
      throw error;
    } finally {
      this.setLoadingVerifyOtp(false);
    }
  };

  setLoadingVerifyOtp = (val: boolean) => {
    this.loadingVerifyOtp = val;
  };
}
